import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createImputationRule,
  deleteImputationRule,
  listImputationRules,
  updateImputationRule,
} from "../api/imputationRules";

const RULES_KEY = ["tawa", "imputation-rules"];

export function useImputationRules(enabled = true) {
  return useQuery({
    queryKey: RULES_KEY,
    queryFn: listImputationRules,
    enabled,
    staleTime: 30_000,
  });
}

function useRuleMutation<A, R>(mutationFn: (a: A) => Promise<R>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => void qc.invalidateQueries({ queryKey: RULES_KEY }),
  });
}

export function useCreateImputationRule() {
  return useRuleMutation(createImputationRule);
}

export function useToggleImputationRule() {
  return useRuleMutation(({ id, active }: { id: string; active: boolean }) =>
    updateImputationRule(id, { active }),
  );
}

export function useDeleteImputationRule() {
  return useRuleMutation(deleteImputationRule);
}
